export default __webpack_public_path__ + "static/media/krona.81452748.png";